// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsView_container_Q9mKa","contentContainer":"SettingsView_contentContainer_l2Xrr SettingsView_container_Q9mKa","content":"SettingsView_content_2eXGx"};